import toast from 'react-hot-toast';

const DOWNLOAD_ERROR_MESSAGE =
  'Dokumento atsisiųsti nepavyko. Bandykite dar kartą vėliau.';

export const downloadAmisPdf = async ({
  getFile,
  response,
  query,
  fileName,
}) => {
  try {
    const result = await getFile(query);

    if (!response.ok || typeof result !== 'string') {
      throw new Error('Document request failed.');
    }

    const normalizedBase64 = result
      .replace(/^data:[^;]+;base64,/, '')
      .replace(/\s/g, '');

    if (!normalizedBase64) {
      throw new Error('Document response was empty.');
    }

    const binary = atob(normalizedBase64);
    if (!binary.startsWith('%PDF-')) {
      throw new Error('Document response was not a PDF.');
    }

    const bytes = new Uint8Array(binary.length);
    for (let index = 0; index < binary.length; index += 1) {
      bytes[index] = binary.charCodeAt(index);
    }

    const objectUrl = URL.createObjectURL(
      new Blob([bytes], { type: 'application/pdf' }),
    );
    const downloadLink = document.createElement('a');
    downloadLink.href = objectUrl;
    downloadLink.download = `${fileName}.pdf`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    setTimeout(() => URL.revokeObjectURL(objectUrl), 0);

    return true;
  } catch {
    toast.error(DOWNLOAD_ERROR_MESSAGE);
    return false;
  }
};
